import React, { FunctionComponent } from 'react';

import styles from './PostRow.module.scss';
import { Grid, GridSize } from '@material-ui/core';
import CardTitle from '../CardTitle';
import ServerError from '../ErrorBoundary/ServerError';
import InstagramPostCard from '../InstagramPostCard';
import TiktokPostCard from '../TiktokPostCard';
import LinkedinPostCard from '../LinkedinPostCard';
import TwitterTweetCard from '../TwitterTweetCard';
import YouTubeVideoCard from '../YouTubeVideoCard';

interface Props {
  data: any;
  title?: string;
  compId?: string;
  isReport?: boolean;
  isError?: any;
  grid?: {
    xs?: GridSize;
    lg?: GridSize;
    md?: GridSize;
    sm?: GridSize;
    xl?: GridSize;
  };
  tabName?: string;
  quoteUrl?: string;
  showPosts?: boolean;
}

const PostRow: FunctionComponent<Props> = ({
  title,
  compId,
  data,
  isReport,
  isError,
  grid,
  tabName,
  quoteUrl,
  showPosts,
}) => {
  const RenderPostCard = () => {
    switch (tabName) {
      case 'tiktok':
        return (
          <TiktokPostCard
            data={data}
            compId={compId!}
            isReport={isReport}
            withoutSlider
            withBigSize
            showConversationPopupFlag
            showFavorite
          />
        );
      case 'twitter':
        return (
          <TwitterTweetCard
            compId={compId!}
            isReport={isReport}
            data={data}
            showConversationFlag
            quoteUrl={quoteUrl}
          />
        );

      case 'linkedin':
        return (
          <LinkedinPostCard data={data} compId="postRow" isReport={isReport} />
        );
      case 'youtube':
        return (
          <YouTubeVideoCard
            data={data}
            isReport={isReport}
            compId="postRow"
            showPosts={showPosts}
            withBigSize
          />
        );

      default:
        return (
          <InstagramPostCard
            data={data}
            isReport={isReport}
            showConversationPopupFlag
            compId={compId!}
          />
        );
    }
  };

  return (
    <ServerError requiredApiCalls={[isError]}>
      <Grid item {...grid} className={styles.PostRow}>
        {title && (
          <Grid item sm={12} style={{ marginTop: '14px' }}>
            <CardTitle title={title} hideIcon showBorderBottom maxFontSize />
          </Grid>
        )}
        <Grid id={compId} item sm={12} className={styles.postCard}>
          <div style={{ width: '50%', margin: '0 auto' }}>
            <RenderPostCard />
          </div>
        </Grid>
      </Grid>
    </ServerError>
  );
};

export default PostRow;
